module.exports = __webpack_public_path__ + "static/img/banner.c36d06ec.png";